import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-system/region/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getLazyTree = (parentCode, params) => {
    return request({
        url: '/api/sino-system/region/lazy-tree',
        method: 'get',
        params: {
            ...params,
            parentCode
        }
    })
}

export const getQuickTree = (parentCode, params) => {
    return request({
        url: '/api/sino-system/region/quick-tree',
        method: 'get',
        params: {
            ...params,
            parentCode
        }
    })
}

export const getDetail = (code) => {
    return request({
        url: '/api/sino-system/region/detail',
        method: 'get',
        params: {
            code
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/sino-system/region/remove',
        method: 'post',
        params: {
            id,
        }
    })
}

export const submit = (row) => {
    return request({
        url: '/api/sino-system/region/submit',
        method: 'post',
        data: row
    })
}

